// Match the Backend's explicit observed completion-count contract. This reader
// does not apply to legacy estimated/derived completion fields or other metrics.
export function readReportedCompletionCount(value) {
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0
    ? value
    : null;
}
